import RtmTripSignalValuesReducer from './RtmTripSignalValues'
import RtmTripGpsValuesReducer from './RtmTripGpsValues'
import RtmEventSignalValuesReducer from './RtmEventSignalValues'
import RtmEventGpsValuesReducer from './RtmEventGpsValues'
import DataAnalyticsEventSignalOverviewValuesReducer from './DataAnalyticsEventSignalOverviewValues'
import DataAnalyticsEventSignalValuesReducer from './DataAnalyticsEventSignalValues'
import DataAnalyticsEventGpsValuesReducer from './DataAnalyticsEventGpsValues'
import DtSignalOverviewValuesReducer from './DtSignalOverviewValues'
import DtSignalValuesReducer from './DtSignalValues'

export default {
  rtmTripSignalValues: RtmTripSignalValuesReducer,
  rtmTripGpsValues: RtmTripGpsValuesReducer,
  rtmEventSignalValues: RtmEventSignalValuesReducer,
  rtmEventGpsValues: RtmEventGpsValuesReducer,
  dataAnalyticsEventSignalOverviewValues: DataAnalyticsEventSignalOverviewValuesReducer,
  dataAnalyticsEventSignalValues: DataAnalyticsEventSignalValuesReducer,
  dataAnalyticsEventGpsValues: DataAnalyticsEventGpsValuesReducer,
  dtSignalOverviewValues: DtSignalOverviewValuesReducer,
  dtSignalValues: DtSignalValuesReducer,
}
